import { Directive, ElementRef, HostListener, Input, OnChanges } from '@angular/core';

@Directive({
    selector: '[pill]'
})
export class PillDirective implements OnChanges {
    // Colors
    dark = '#222';
    light = '#fff';
    green = '#5DD879';
    darkgreen = '#2DBC4E';
    red = '#E56B77';
    darkred = '#D44B59';
    blue = '#59A9FF';
    darkblue = '#0c86b6';
    orange = '#FD9A47';
    amber = '#FFC000';
    yellow = '#FFC107';
    grey = '#CED4DA';
    purple = '#BA55D3';
    black = '#000';

    // Formatting
    formatting = {
        maxHeight: '1.45em',
        display: 'block',
        lineHeight: '1.45em',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: '0 0.5em 0 0.5em',
        borderRadius: '4px',
        color: this.dark,
        fontWeight: 'bold',
        textAlign: 'center',
        textDecoration: 'none'
    };

    // Status, module & muted input
    @Input() pill: { status: string, module: string };

    el: ElementRef;

    constructor(el: ElementRef) {
        this.el = el;

        // Apply formatting
        for (const prop in this.formatting) {
            if (this.el.nativeElement.style.hasOwnProperty(prop)) {
                this.el.nativeElement.style[prop] = this.formatting[prop];
            }
        }
    }

    ngOnChanges() {
        const color = this.pillColor(this.pill);
        this.el.nativeElement.style.color = color === this.black ? '#fff' : '#000';
        this.el.nativeElement.style.backgroundColor = color;
    }

    private textColor(color: string): void {
        this.el.nativeElement.style.color = color;
    }

    private pillColor(input: any): string {
        const status = input.status?.toUpperCase();
        const module = input.module;

        if (module === 'VesselVisit') {
            switch (status) {
                case 'PRE': return this.yellow;
                case 'ANN': return this.blue;
                case 'ARR': return this.green;
                case 'DEP': return this.purple;
                case 'ANC': return this.orange;
                case 'CAN': return this.red;
            }
        } else if (module === 'ServiceRequest') {
            switch (status) {
                case 'SAV': return this.black;
                case 'PEN': return this.orange;
                case 'CAN': return this.red;
                case 'INP': return this.blue;
                case 'DEC': return this.purple;
                case 'COM': return this.green;
            }
        } else if (module === 'WarehouseDocument') {
            switch (status) {
                case 'SAV': return this.blue;
                case 'COM': return this.green;
                case 'CAN': return this.red;
            }
        } else if (module === 'VesselVisitDocumentStatus') {
            switch (status) {
                case 'WAP': return this.yellow;
                case 'WFA': return this.darkblue;
                case 'WFD': return this.blue;
                case 'APP': return this.green;
                case 'REJ': return this.red;
                case 'ACK': return this.purple;
                case 'CAN': return this.darkred;
            }
        }
        return this.grey;
    }
}
